import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import { lightTheme, darkTheme } from "./theme";
import { useState, useEffect } from "react";
import { Box, CssBaseline, Container } from "@mui/material";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Notes from "./components/Notes";
import { Route, Routes } from "react-router-dom";
import Board from "./components/Board";
import NotFound from "./components/NotFound";

function App() {
    const [darkMode, setDarkMode] = useState(() => {
        const storedTheme = localStorage.getItem("notes_bl_theme");
        return storedTheme === "dark";
    });

    useEffect(() => {
        const html = document.documentElement;
        const theme = darkMode ? "dark" : "light";
        html.setAttribute("data-theme", theme);
        localStorage.setItem("notes_bl_theme", darkMode ? "dark" : "light");
    }, [darkMode]);

    const setThemeMode = (isDark) => {
        setDarkMode(isDark);
    };

    return (
        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
            <CssBaseline />
            <Box
                sx={{
                    width: "100%",
                    minHeight: "100vh",
                    backgroundColor: (theme) =>
                        theme.palette.background.default,
                }}
            >
                <Routes>
                    <Route
                        path="/"
                        element={
                            <div className="App">
                                <Container maxWidth="md">
                                    <Navbar setThemeMode={setThemeMode} />
                                    <Notes />
                                </Container>
                            </div>
                        }
                    />

                    <Route
                        path="/board"
                        element={<Board setThemeMode={setThemeMode} />}
                    />

                    <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
            </Box>
        </ThemeProvider>
    );
}

export default App;
